import React, { useEffect } from 'react'
import XLSX from 'xlsx'
import { Button, Input, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CollapsibleCard from 'Components/collapsibleCard'
import { useSelector, useDispatch } from 'react-redux'
import DynamicTable from 'Components/dynamicTable'
import { dataParse, setInputHeaders, batchCreationStatusReset, resetImportForm } from 'Reducers/dataImportReducer'
import { DatasetStore } from 'Stores/datasetStore'
import { useState } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'

var importFile = null
var importFileData = null
export default class ImportPoints extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <React.Fragment>
        <ImportPointsComponent props={this.props} />
      </React.Fragment>
    )
  }
}

function saveBatch(batchObj) {
  let dataset = new DatasetStore()
  dataset.saveBatch(batchObj)
}

function ImportPointsComponent({ props }) {
  const platformData = useSelector(state => state.login.settings)
  const parsedData = useSelector(state => state.dataImport.parsedData)
  const inputHeaders = useSelector(state => state.dataImport.inputHeaders)
  const batchCreationSuccessful = useSelector(state => state.dataImport.batchCreationSuccessful)
  const batchCreationFailed = useSelector(state => state.dataImport.batchCreationFailed)
  const [submitButtonEnabled, setSubmitButtonEnabled] = useState(false)
  const dispatch = useDispatch()
  const batchComment = `Manual Import by ${platformData.userName}`
  let options = {}
  let validationSuccess = false
  const enableWalletActivation = platformData && platformData.features && platformData.features.enableWalletActivation
  const UID_COL = enableWalletActivation ? 1805 : 101
  const POINT_COL = enableWalletActivation ? 1801 : 3
  const defaultPointsImportHeaders = [
    { columnName: 'UID', DatacolumnID: enableWalletActivation ? 1805 : 101, dataType: 'string', ColumnNo: 1 },
    { columnName: 'Point', DatacolumnID: enableWalletActivation ? 1801 : 3, dataType: 'number', ColumnNo: 2 },
    { columnName: 'Reference', DatacolumnID: enableWalletActivation ? 1802 : 13, dataType: 'string', ColumnNo: 3 },
    { columnName: 'Dato', DatacolumnID: enableWalletActivation ? 1807 : 127, dataType: 'date', ColumnNo: 4 },
    { columnName: 'Vault (hvis aktuel)', DatacolumnID: enableWalletActivation ? 1810 : 1610, dataType: 'string', ColumnNo: 5 }
  ]
  const regExp = /.*\(.*\).*/

  const customHeaders =
    platformData && platformData.features && platformData.features.pointImportHeaders && platformData.features.pointImportHeaders.length > 0
      ? platformData.features.pointImportHeaders
      : null
  const headers = customHeaders ? customHeaders : defaultPointsImportHeaders
  const fileHeaders = customHeaders ? customHeaders.map(item => item.columnName) : defaultPointsImportHeaders.map(item => item.columnName)

  const downloadEXCEL = () => {
    let xlData = []
    xlData.push(fileHeaders)
    let worksheet = XLSX.utils.aoa_to_sheet(xlData)
    let workbook = new XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'download')
    XLSX.writeFile(workbook, 'Points-Import-template.xlsx')
  }

  useEffect(() => {
    dispatch(resetImportForm())
  }, [])

  const parseCsvString = (result, batchData) => {
    let records = result.split('\n')
    let csvDataString = ''
    records.map(item => {
      let data = item.trim()
      let csv = data.replace('/;/g', '').trim()
      if (csv.length > 1) {
        csvDataString = csvDataString + item + '\n'
      }
    })
    batchData.batchFiles[0].csvDataString = csvDataString
    saveBatch(batchData) // -- api call
  }

  const prepareBatchOptions = () => {
    let columns = []
    headers.map(item => {
      let obj = {
        DatacolumnID: item.DatacolumnID,
        csvColumnDefault: '',
        csvColumnMatchExpression: '',
        csvColumnMatchValue: '',
        csvColumnNo: `${item.ColumnNo}`
      }
      columns.push(obj)
    })

    return {
      skipHeader: true,
      columns: columns
    }
  }

  const identifyBatchRole = () => {
    const brandsThatUseClientRole = [1, 2, 3, 4, 5]
    if (brandsThatUseClientRole.includes(platformData.BrandID)) {
      return 'Client'
    } else {
      return 'Brand'
    }
  }

  const handleExcelUpload = e => {
    e.preventDefault()
    let files = e.target.files
    importFile = files[0]
    let reader = new FileReader()
    reader.onload = function(e) {
      importFileData = e.target.result
      let readedData = XLSX.read(importFileData, { type: 'binary', cellDates: true, raw: true })
      const wsname = readedData.SheetNames[0]
      const ws = readedData.Sheets[wsname]
      const sheetData = XLSX.utils.sheet_to_json(ws, { header: 1, ...(platformData.BrandID === 16 && { raw: false }) })
      let fileValidation = []
      let errorMessage = null
      if (sheetData && sheetData.length > 0) {
        if (JSON.stringify(fileHeaders) !== JSON.stringify(sheetData[0])) {
          fileValidation = sheetData[0].map(item =>
            fileHeaders.some(header =>
              header.toLowerCase().includes(
                regExp.test(item)
                  ? item
                      .split('(')[0]
                      .trim()
                      .toLowerCase()
                  : item.trim().toLowerCase()
              )
            )
          )
        }
        if (sheetData.length < 2) {
          errorMessage =
            (fileValidation && !fileValidation.includes(false)) || !fileValidation.length
              ? 'Data mangler. Venligst upload ny korrekt fil med data.'
              : null
        }
      } else {
        errorMessage = 'Filen er tom. Venligst upload ny korrekt fil med data.'
      }
      if ((fileValidation && fileValidation.includes(false)) || errorMessage) {
        toast.error(errorMessage ? errorMessage : 'Forkert fil skabelon. Venligst upload korrekt skabelon', {
          autoClose: 3000
        })
        dispatch(batchCreationStatusReset())
        return
      }
      dispatch(dataParse(sheetData))
    }
    reader.readAsBinaryString(importFile)
  }

  const initiateBatchCreation = (sheetData = parsedData, file = importFile, data = importFileData) => {
    if (sheetData && file && data) {
      let csvContent = ''
      let batchData = {}
      batchData.DatasetID = enableWalletActivation ? 103 : 2 // Points
      batchData.batchComment = batchComment
      batchData.batchEncoding = 'UTF-8'
      batchData.batchOptions = prepareBatchOptions()
      batchData.batchRole = identifyBatchRole()
      batchData.skipHeader = 'on'
      batchData.uniqueConstraint = ''
      sheetData.forEach(function(infoArray, index) {
        let dataString = ''
        for (let info of infoArray) {
          if (info && info.toString().indexOf(';') >= 0) {
            dataString += `"${info}";`
          } else {
            dataString += `${info ? info : ''};`
          }
        }
        csvContent += index < sheetData.length ? dataString + '\n' : dataString
      })
      batchData.batchFiles = {
        File: file,
        contentType: file.type,
        fileExtension: file.type.split('/')[1],
        name: file.name
      }
      batchData.batchFiles.csvDataString = data
      batchData.batchFiles = [batchData.batchFiles]
      parseCsvString(csvContent, batchData)
    }
  }

  const prepareTableData = (sheetData = parsedData) => {
    let tableData = []
    if (sheetData && sheetData.length) {
      let inputfileHeaders = sheetData[0]
      if (inputfileHeaders.length) {
        dispatch(setInputHeaders(inputfileHeaders))
        sheetData.forEach((item, i) => {
          let obj = {
            rowNo: i + 1
          }
          inputHeaders.forEach((val, index) => {
            if (item[index] && item[index].toString().trim() !== '') {
              obj[val] = item[index]
            }
          })
          if (i > 0 && Object.keys(obj).length > 1) {
            const trimmedRow = Object.entries(obj).reduce((acc, curr) => {
              let [key, value] = curr
              acc[typeof key === 'string' ? key.trim() : key] = typeof value === 'string' ? value.trim() : value
              return acc
            }, {})
            tableData.push(trimmedRow)
          }
        })
        tableData = validateTableData(tableData)
        return tableData
      }
    }
    return []
  }

  useEffect(() => {
    if (validationSuccess) {
      setSubmitButtonEnabled(true)
    } else {
      setSubmitButtonEnabled(false)
    }
    if (batchCreationSuccessful === true) {
      toast.success('Batch created successfully', {
        autoClose: 3000
      })
      dispatch(batchCreationStatusReset())
      props.history.push('/import/points')
    }
    if (batchCreationFailed === true) {
      toast.error('Batch creation Failed. Please try again', {
        autoClose: 3000
      })
      dispatch(batchCreationStatusReset())
    }
  })

  const validateTableData = tableData => {
    validationSuccess = true
    let columns = customHeaders ? customHeaders : defaultPointsImportHeaders
    for (let row of tableData) {
      row.error = []
      for (let column of columns) {
        let columnName =
          column.columnName in row
            ? column.columnName
            : regExp.test(column.columnName)
            ? inputHeaders.includes(column.columnName.split('(')[0].trim())
              ? column.columnName.split('(')[0].trim()
              : column.columnName
            : column.columnName
        const cellData = row[columnName]
        // Mandatory validations
        if (column.DatacolumnID === UID_COL && !cellData) {
          validationSuccess = false
          if (!(columnName in row)) {
            row[columnName] = null
          }
          row.error.push(columnName)
        }
        if (column.DatacolumnID === POINT_COL && !cellData) {
          validationSuccess = false
          if (!(columnName in row)) {
            row[columnName] = null
          }
          row.error.push(columnName)
        }
        let date = null
        switch (column.dataType) {
          case 'number':
            if (cellData && (cellData === 0 || isNaN(cellData))) {
              validationSuccess = false
              row.error.push(columnName)
            }
            break
          case 'email':
            if (
              cellData &&
              !/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(cellData.trim())
            ) {
              validationSuccess = false
              row.error.push(columnName)
            }
            break
          case 'date':
            if (cellData) {
              date = moment(cellData, 'DD.MM.YYYY')
              if (!date || !date.isValid()) {
                date = moment(cellData, 'DD-MM-YYYY')
                if (!date.isValid()) {
                  validationSuccess = false
                  row.error.push(columnName)
                }
              }
              if (date > new Date()) {
                validationSuccess = false
                row.error.push(columnName)
              }
            }
            break
          default:
            break
        }
      }
    }
    return tableData
  }

  const handleSubmit = () => {
    initiateBatchCreation()
  }

  return (
    <CollapsibleCard
      startOpen
      header={
        <strong>
          Upload point fil
          <span className='float-right'>
            <Button
              className='margin-5'
              onClick={() => {
                downloadEXCEL()
              }}
            >
              Download tomt Excel ark til oprettelse <FontAwesomeIcon icon='file-excel' />
            </Button>
          </span>
        </strong>
      }
    >
      <label className='select-file-button margin-5' htmlFor='fileupload'>
        Vælg Excel/CSV fil til upload <FontAwesomeIcon icon='file-excel' />
      </label>
      <Input
        onChange={event => {
          handleExcelUpload(event)
        }}
        onClick={event => {
          event.target.value = null
        }}
        id='fileupload'
        type='file'
        className='display-none'
      />
      <Button disabled={!submitButtonEnabled} onClick={handleSubmit}>
        Upload Excel/CSV
      </Button>
      {parsedData && parsedData.length && !submitButtonEnabled && (
        <React.Fragment>
          <Row className='ml-2 mb-2' style={{ color: 'red' }}>
            Fremhævede celler mangler enten obligatoriske værdier eller har forkert format. Venligst se nedenfor og upload en ny tilrettet fil
          </Row>
          <Row className='ml-2'>Nogle eksempler på korrekte data:</Row>
          <Row className='ml-5'>&#8226; UID - Feltet må ikke være blankt ( 123/ 123test / 123@test.com )</Row>
          <Row className='ml-5'>&#8226; Point - Feltet skal være et tal (100 / -100)</Row>
          <Row className='ml-5 mb-3'>&#8226; Dato - dd.mm.åååå eller dd-mm-åååå ( 26.05.2021 / 26-05-2021 ) Dato kan ikke være større end d.d.</Row>
        </React.Fragment>
      )}
      <DynamicTable data={prepareTableData(parsedData)} options={options} headers={['rowNo'].concat(...inputHeaders.map(header => header.trim()))} />
    </CollapsibleCard>
  )
}
